import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrganisationComponent } from './organisation.component'

const routes: Routes = [
  { path: ':lang/:education-type/:education-type-id/o', pathMatch: 'full', component: OrganisationComponent, runGuardsAndResolvers: 'always' },
  { path: ':lang/:education-type/:organisation-unit/:education-type-id/:organisation-unit-id', pathMatch: 'full', component: OrganisationComponent, runGuardsAndResolvers: 'always' },
  // alempi koskee taideyliopiston valikkorakennetta 
  { path: ':lang/:organisation/:organisation-unit-id/e', pathMatch: 'full', component: OrganisationComponent, runGuardsAndResolvers: 'always' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrganisationRoutingModule { }
